import { SxProps, Typography } from '@mui/material';
import React from 'react';

interface ITextProps {
    children?: any;
    textSize: number;
    variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'button' | 'caption' | 'overline' | 'inherit' | undefined;
    color?: 'initial' | 'inherit' | 'primary' | 'secondary' | 'text.primary' | 'text.secondary' | 'text.disabled' | 'error' | undefined;
    align?: 'inherit' | 'left' | 'center' | 'right' | 'justify' | undefined;
    style: SxProps;
    onClick?: any;
}

const AppText: React.FC<ITextProps> = ({ textSize, children, variant, color, align, style, onClick }) => {
    return (
        <Typography variant={variant} color={color} align={align} sx={{ fontSize: { xs: textSize * 0.75, sm: textSize }, ...style }} onClick={onClick}>
            {children}
        </Typography>
    );
};

export default AppText;
